import MessagesListOutboxContainer from './messages_list_outbox_container';

const MessagesListOutbox = MessagesListOutboxContainer;
export default MessagesListOutbox;
